import { Avatar, useToast } from "@chakra-ui/react";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import type { onErrorCb } from "@/api/types";
import { CameraIcon, FilePlusIcon, TrashOutlineIcon } from "@/components/icons";
// import { svgToPng } from "@/lib/utils/svg-to-png";
import styles from "./styles.module.scss";

type Props = {
  imageUrl?: string;
  onChange: (image?: string) => void;
  fullWidth?: boolean;
  height?: string;
  uploadFunc: (body: FormData, onError?: onErrorCb) => Promise<string | null>;
};

export function ImageUploader(props: Props) {
  const { t } = useTranslation();
  const toast = useToast();

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const setImage = async () => {
        const files = e.target.files;
        if (!files) {
          return;
        }
        const file = files[0];
        if (!file) {
          return;
        }

        const formData = new FormData();

        // TODO: temporarily skip SVG to PNG conversion
        // if (file.name.toLowerCase().endsWith(".svg") || file.type === "image/svg+xml") {
        //   try {
        //     const png = await svgToPng(file);
        //     formData.append("file", png);
        //   } catch {
        //     toast({
        //       title: t("imageUploader.error.title", {
        //         defaultValue: "Не удалось обновить изображение",
        //       }),
        //       status: "error",
        //       duration: 5000,
        //       isClosable: true,
        //     });
        //     return;
        //   }
        // } else {
        // formData.append("file", file);
        // }
        formData.append("file", file);

        const imageID = await props.uploadFunc(formData, () => {
          toast({
            title: t("imageUploader.error.title", {
              defaultValue: "Не удалось обновить изображение",
            }),
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        });
        if (imageID) {
          props.onChange(imageID);
        }
      };

      void setImage();
    },
    [props, t, toast],
  );

  const onDelete = React.useCallback(() => {
    props.onChange(undefined);
  }, [props]);

  return (
    <div
      className={clsx([styles.fileWrapper, props.fullWidth && styles.fullWidth])}
      style={{ height: props.height }}
    >
      {props.imageUrl ? (
        <button className={styles.fileAction} onClick={onDelete}>
          <TrashOutlineIcon size={32} color="#e10f0f" />
        </button>
      ) : (
        <label className={styles.fileAction}>
          <FilePlusIcon size={32} />

          <input
            className={styles.fileInput}
            type="file"
            accept=".jpg, .jpeg, .png, .svg, .ico"
            onChange={onChange}
            name="image"
          />
        </label>
      )}
      <Avatar
        width={props.fullWidth ? "100%" : undefined}
        height={"100%"}
        borderRadius={5}
        size={"sm"}
        src={props.imageUrl}
        icon={<CameraIcon size={30} />}
        // backgroundColor={"brand.clear"}
        backgroundColor={"gray.300"}
        _dark={{ bg: "gray.500" }}
      />
    </div>
  );
}
